export default{
    与我们联系:"與我們聯繫",
    专属客户经理将尽快联系您:"",
    立即参与:"立即參與",
}